import { useContext } from 'react';

import { ServiceContext } from 'contexts/serviceContext';

export function useServiceFeatures() {
  const serviceFeatures = useContext(ServiceContext);
  return serviceFeatures;
}
